module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-form"
  }, [_c('joi-form', {
    attrs: {
      "data": _vm.data,
      "schema": _vm.validationSchema,
      "error": _vm.formError
    },
    on: {
      "formdataready": _vm.save
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-4 columns small-centered"
  }, [_c('span', {
    attrs: {
      "data-form-error-callout": ""
    }
  })])]), _vm._v(" "), (_vm.data.id) ? _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 medium-4 columns"
  }, [_c('label', [_vm._v("Utolsó beolvasás:")]), _vm._v(" "), _c('div', {
    staticClass: "displayfield"
  }, [_vm._v("\n          " + _vm._s(_vm.lastReadingInf)), _c('br'), _vm._v(" "), (_vm.data.id) ? _c('button', {
    staticClass: "button tiny primary trans-uppercase",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("Letöltés")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row expanded",
    attrs: {
      "av-if": "data.rssUrl"
    }
  }, [_c('div', {
    staticClass: "small-12 columns"
  }, [_c('label', {
    staticStyle: {
      "padding-bottom": "10px"
    }
  }, [_vm._v("\n          RSS URL: "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.data.rssUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.data.rssUrl))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 medium-4 columns"
  }, [_c('label', [_vm._v("\n          Megnevezés:\n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.title),
      expression: "data.title"
    }],
    attrs: {
      "type": "text",
      "name": "title"
    },
    domProps: {
      "value": (_vm.data.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "title", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 medium-4 columns"
  }, [_c('label', {
    attrs: {
      "error-path": "channels"
    }
  }, [_vm._v("\n          Oldalak:\n          "), _c('channel-selector', {
    model: {
      value: (_vm.data.channels),
      callback: function($$v) {
        _vm.$set(_vm.data, "channels", $$v)
      },
      expression: "data.channels"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 columns"
  }, [_c('label', [_vm._v("\n          Stratégia:\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.strategy),
      expression: "data.strategy"
    }],
    attrs: {
      "id": "strategy-thresholds",
      "type": "radio",
      "value": "thresholds"
    },
    domProps: {
      "checked": _vm._q(_vm.data.strategy, "thresholds")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.data, "strategy", "thresholds")
      }
    }
  }), _c('label', {
    attrs: {
      "for": "strategy-thresholds"
    }
  }, [_vm._v("Határértékek")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.strategy),
      expression: "data.strategy"
    }],
    attrs: {
      "id": "strategy-top",
      "type": "radio",
      "value": "top"
    },
    domProps: {
      "checked": _vm._q(_vm.data.strategy, "top")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.data, "strategy", "top")
      }
    }
  }), _c('label', {
    attrs: {
      "for": "strategy-top"
    }
  }, [_vm._v("Top N")]), _vm._v(" "), _c('span', {
    attrs: {
      "error-path": "strategy"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-4 medium-2 columns"
  }, [_c('label', [_vm._v("\n          Referencia időpont:\n          "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-label"
  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.readTimeOffsetInDays),
      expression: "data.readTimeOffsetInDays"
    }],
    staticClass: "input-group-field",
    attrs: {
      "type": "number",
      "name": "readTimeOffsetInDays",
      "min": "0"
    },
    domProps: {
      "value": (_vm.data.readTimeOffsetInDays)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "readTimeOffsetInDays", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-label"
  }, [_vm._v("nap")])]), _vm._v(" "), _c('label', {
    attrs: {
      "error-path": "readTimeOffsetInDays"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "small-4 medium-2 end columns"
  }, [_c('label', [_vm._v("\n          Visszamenőleg:\n          "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.topHours),
      expression: "data.topHours"
    }],
    staticClass: "input-group-field",
    attrs: {
      "type": "number",
      "name": "topHours"
    },
    domProps: {
      "value": (_vm.data.topHours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "topHours", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-label"
  }, [_vm._v("óra")])]), _vm._v(" "), _c('label', {
    attrs: {
      "error-path": "topHours"
    }
  })])])]), _vm._v(" "), (_vm.data.strategy === 'top') ? _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-4 medium-2 columns"
  }, [_c('label', [_vm._v("\n          Top N:\n          "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.topCount),
      expression: "data.topCount"
    }],
    staticClass: "input-group-field",
    attrs: {
      "type": "number",
      "name": "topCount"
    },
    domProps: {
      "value": (_vm.data.topCount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "topCount", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-label"
  }, [_vm._v("db.")])]), _vm._v(" "), _c('label', {
    attrs: {
      "error-path": "topCount"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "small-4 medium-2 columns"
  }, [_c('label', [_vm._v("\n          Szempont:\n          "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.topOrder),
      expression: "data.topOrder"
    }],
    attrs: {
      "name": "topOrder"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "topOrder", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "like"
    }
  }, [_vm._v("Like")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "share"
    }
  }, [_vm._v("Share")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "comment"
    }
  }, [_vm._v("Comment")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "reach"
    }
  }, [_vm._v("Reach")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "click"
    }
  }, [_vm._v("Click")])])])]), _vm._v(" "), _c('div', {
    staticClass: "small-4 medium-2 end columns"
  }, [_c('label', [_vm._v("\n          Időpont:\n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.topTime),
      expression: "data.topTime"
    }],
    attrs: {
      "type": "time",
      "name": "topTime"
    },
    domProps: {
      "value": (_vm.data.topTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "topTime", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 columns"
  }, [_c('label', [_vm._v("\n          Poszt típusok:\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.postTypes),
      expression: "data.postTypes"
    }],
    attrs: {
      "id": "post-type-status",
      "type": "checkbox",
      "value": "status"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.postTypes) ? _vm._i(_vm.data.postTypes, "status") > -1 : (_vm.data.postTypes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.postTypes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "status",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "postTypes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "postTypes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "postTypes", $$c)
        }
      }
    }
  }), _c('label', {
    attrs: {
      "for": "post-type-status"
    }
  }, [_vm._v("Státusz")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.postTypes),
      expression: "data.postTypes"
    }],
    attrs: {
      "id": "post-type-link",
      "type": "checkbox",
      "value": "link"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.postTypes) ? _vm._i(_vm.data.postTypes, "link") > -1 : (_vm.data.postTypes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.postTypes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "link",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "postTypes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "postTypes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "postTypes", $$c)
        }
      }
    }
  }), _c('label', {
    attrs: {
      "for": "post-type-link"
    }
  }, [_vm._v("Link")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.postTypes),
      expression: "data.postTypes"
    }],
    attrs: {
      "id": "post-type-photo",
      "type": "checkbox",
      "value": "photo"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.postTypes) ? _vm._i(_vm.data.postTypes, "photo") > -1 : (_vm.data.postTypes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.postTypes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "photo",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "postTypes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "postTypes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "postTypes", $$c)
        }
      }
    }
  }), _c('label', {
    attrs: {
      "for": "post-type-photo"
    }
  }, [_vm._v("Kép")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.postTypes),
      expression: "data.postTypes"
    }],
    attrs: {
      "id": "post-type-video",
      "type": "checkbox",
      "value": "video"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.postTypes) ? _vm._i(_vm.data.postTypes, "video") > -1 : (_vm.data.postTypes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.postTypes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "video",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "postTypes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "postTypes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "postTypes", $$c)
        }
      }
    }
  }), _c('label', {
    attrs: {
      "for": "post-type-video"
    }
  }, [_vm._v("Videó")]), _vm._v(" "), _c('span', {
    attrs: {
      "error-path": "postTypes"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-4 medium-2 columns"
  }, [_c('label', [_vm._v("\n          Like:\n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.thresholdLike),
      expression: "data.thresholdLike"
    }],
    attrs: {
      "type": "text",
      "name": "thresholdLike"
    },
    domProps: {
      "value": (_vm.data.thresholdLike)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "thresholdLike", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-4 medium-2 columns"
  }, [_c('label', [_vm._v("\n          Share:\n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.thresholdShare),
      expression: "data.thresholdShare"
    }],
    attrs: {
      "type": "text",
      "name": "thresholdShare"
    },
    domProps: {
      "value": (_vm.data.thresholdShare)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "thresholdShare", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-4 medium-2 columns"
  }, [_c('label', [_vm._v("\n          Comment:\n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.thresholdComment),
      expression: "data.thresholdComment"
    }],
    attrs: {
      "type": "text",
      "name": "thresholdComment"
    },
    domProps: {
      "value": (_vm.data.thresholdComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "thresholdComment", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-4 medium-2 columns"
  }, [_c('label', [_vm._v("\n          Reach:\n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.thresholdReach),
      expression: "data.thresholdReach"
    }],
    attrs: {
      "type": "text",
      "name": "thresholdReach"
    },
    domProps: {
      "value": (_vm.data.thresholdReach)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "thresholdReach", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-4 medium-2 columns"
  }, [_c('label', [_vm._v("\n          Click:\n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.thresholdClick),
      expression: "data.thresholdClick"
    }],
    attrs: {
      "type": "text",
      "name": "thresholdClick"
    },
    domProps: {
      "value": (_vm.data.thresholdClick)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "thresholdClick", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-4 medium-2 columns"
  }, [_c('label', [_vm._v("\n          Max. elemszám:\n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.maxItemNum),
      expression: "data.maxItemNum"
    }],
    attrs: {
      "type": "text",
      "name": "maxItemNum"
    },
    domProps: {
      "value": (_vm.data.maxItemNum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "maxItemNum", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 columns"
  }, [_c('label', [_vm._v("\n          Hivatkozások:\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.useLinks),
      expression: "data.useLinks"
    }],
    attrs: {
      "id": "use-links-link",
      "type": "radio",
      "value": "link"
    },
    domProps: {
      "checked": _vm._q(_vm.data.useLinks, "link")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.data, "useLinks", "link")
      }
    }
  }), _c('label', {
    attrs: {
      "for": "use-links-link"
    }
  }, [_vm._v("Eredeti hivatkozások")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.useLinks),
      expression: "data.useLinks"
    }],
    attrs: {
      "id": "use-links-permalink",
      "type": "radio",
      "value": "permalink"
    },
    domProps: {
      "checked": _vm._q(_vm.data.useLinks, "permalink")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.data, "useLinks", "permalink")
      }
    }
  }), _c('label', {
    attrs: {
      "for": "use-links-permalink"
    }
  }, [_vm._v("Facebook hivatkozások")]), _vm._v(" "), _c('span', {
    attrs: {
      "error-path": "useLinks"
    }
  })])]), _vm._v(" "), (_vm.data.useLinks === 'permalink') ? _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 columns"
  }, [_c('label', [_vm._v("\n          Beszédes hivatkozások használata:\n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.usePrettyLinks),
      expression: "data.usePrettyLinks"
    }],
    attrs: {
      "id": "usePrettyLinks",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.usePrettyLinks) ? _vm._i(_vm.data.usePrettyLinks, null) > -1 : (_vm.data.usePrettyLinks)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.usePrettyLinks,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "usePrettyLinks", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "usePrettyLinks", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "usePrettyLinks", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "help-text"
  }, [_vm._v("https://www.facebook.com/132535353/posts/1368792145283210 "), _c('b', [_vm._v("helyett")]), _vm._v(" https://www.facebook.com/oldalnev/posts/1368792145283210")]), _vm._v(" "), _c('span', {
    attrs: {
      "error-path": "usePrettyLinks"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 columns"
  }, [_c('label', [_vm._v("\n          Tartalom:\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.useContents),
      expression: "data.useContents"
    }],
    attrs: {
      "id": "use-feed-contents",
      "type": "radio",
      "value": "feed"
    },
    domProps: {
      "checked": _vm._q(_vm.data.useContents, "feed")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.data, "useContents", "feed")
      }
    }
  }), _c('label', {
    attrs: {
      "for": "use-feed-contents"
    }
  }, [_vm._v("Feedben szereplő")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.useContents),
      expression: "data.useContents"
    }],
    attrs: {
      "id": "use-remote-contents",
      "type": "radio",
      "value": "remote"
    },
    domProps: {
      "checked": _vm._q(_vm.data.useContents, "remote")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.data, "useContents", "remote")
      }
    }
  }), _c('label', {
    attrs: {
      "for": "use-remote-contents"
    }
  }, [_vm._v("Távoli tartalom")]), _vm._v(" "), _c('span', {
    attrs: {
      "error-path": "useContents"
    }
  })])]), _vm._v(" "), (_vm.data.useLinks === 'link') ? _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 medium-4 columns"
  }, [_c('label', [_vm._v("\n          Átadott paraméterek:\n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.passedParams),
      expression: "data.passedParams"
    }],
    attrs: {
      "type": "text",
      "name": "passedParams"
    },
    domProps: {
      "value": (_vm.data.passedParams)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "passedParams", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 columns"
  }, [_c('label', [_vm._v("\n          Hirstop használata:\n          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.rewriteUrl),
      expression: "data.rewriteUrl"
    }],
    attrs: {
      "id": "rewriteUrl",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.rewriteUrl) ? _vm._i(_vm.data.rewriteUrl, null) > -1 : (_vm.data.rewriteUrl)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.rewriteUrl,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "rewriteUrl", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "rewriteUrl", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "rewriteUrl", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('span', {
    attrs: {
      "error-path": "rewriteUrl"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 medium-4 columns"
  }, [_c('label', [_vm._v("\n          Az eredeti hivatkozás tartalmazza:\n          "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.filterLink),
      expression: "data.filterLink"
    }],
    domProps: {
      "value": (_vm.data.filterLink)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "filterLink", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-4 end columns"
  }, [_c('label', [_vm._v("\n          Az eredeti hivatkozás NEM tartalmazza:\n          "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.filterLinkNot),
      expression: "data.filterLinkNot"
    }],
    domProps: {
      "value": (_vm.data.filterLinkNot)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "filterLinkNot", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 medium-4 columns"
  }, [_c('label', [_vm._v("\n          A Facebook link tartalmazza:\n          "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.filterPermaLink),
      expression: "data.filterPermaLink"
    }],
    domProps: {
      "value": (_vm.data.filterPermaLink)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "filterPermaLink", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-4 end columns"
  }, [_c('label', [_vm._v("\n          A Facebook link NEM tartalmazza:\n          "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.filterPermaLinkNot),
      expression: "data.filterPermaLinkNot"
    }],
    domProps: {
      "value": (_vm.data.filterPermaLinkNot)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "filterPermaLinkNot", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 medium-4 columns"
  }, [_c('label', [_vm._v("\n          Az üzenet tartalmazza:\n          "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.filterMessage),
      expression: "data.filterMessage"
    }],
    domProps: {
      "value": (_vm.data.filterMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "filterMessage", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-4 end columns"
  }, [_c('label', [_vm._v("\n          Az üzenet NEM tartalmazza:\n          "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.filterMessageNot),
      expression: "data.filterMessageNot"
    }],
    domProps: {
      "value": (_vm.data.filterMessageNot)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "filterMessageNot", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 medium-4 columns"
  }, [_c('label', [_vm._v("\n          A \"page title\" mező tartalmazza:\n          "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.filterMetaTitle),
      expression: "data.filterMetaTitle"
    }],
    domProps: {
      "value": (_vm.data.filterMetaTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "filterMetaTitle", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-4 end columns"
  }, [_c('label', [_vm._v("\n          A \"page title\" mező NEM tartalmazza:\n          "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.filterMetaTitleNot),
      expression: "data.filterMetaTitleNot"
    }],
    domProps: {
      "value": (_vm.data.filterMetaTitleNot)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "filterMetaTitleNot", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 medium-4 columns"
  }, [_c('label', [_vm._v("\n          A \"meta description\" mező tartalmazza:\n          "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.filterMetaDescription),
      expression: "data.filterMetaDescription"
    }],
    domProps: {
      "value": (_vm.data.filterMetaDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "filterMetaDescription", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-4 end columns"
  }, [_c('label', [_vm._v("\n          A \"meta description\" mező NEM tartalmazza:\n          "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.filterMetaDescriptionNot),
      expression: "data.filterMetaDescriptionNot"
    }],
    domProps: {
      "value": (_vm.data.filterMetaDescriptionNot)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "filterMetaDescriptionNot", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 medium-4 columns"
  }, [_c('label', [_vm._v("\n          Az \"OG title\" mező tartalmazza:\n          "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.filterOgTitle),
      expression: "data.filterOgTitle"
    }],
    domProps: {
      "value": (_vm.data.filterOgTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "filterOgTitle", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-4 end columns"
  }, [_c('label', [_vm._v("\n          Az \"OG title\" mező NEM tartalmazza:\n          "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.filterOgTitleNot),
      expression: "data.filterOgTitleNot"
    }],
    domProps: {
      "value": (_vm.data.filterOgTitleNot)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "filterOgTitleNot", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 medium-4 columns"
  }, [_c('label', [_vm._v("\n          Az \"OG description\" mező tartalmazza:\n          "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.filterOgDescription),
      expression: "data.filterOgDescription"
    }],
    domProps: {
      "value": (_vm.data.filterOgDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "filterOgDescription", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-4 end columns"
  }, [_c('label', [_vm._v("\n          Az \"OG description\" mező NEM tartalmazza:\n          "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.filterOgDescriptionNot),
      expression: "data.filterOgDescriptionNot"
    }],
    domProps: {
      "value": (_vm.data.filterOgDescriptionNot)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "filterOgDescriptionNot", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-12 medium-4 columns"
  }, [_c('label', [_vm._v("\n          Az \"Author\" mező tartalmazza:\n          "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.filterCustomAuthor),
      expression: "data.filterCustomAuthor"
    }],
    domProps: {
      "value": (_vm.data.filterCustomAuthor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "filterCustomAuthor", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "small-12 medium-4 end columns"
  }, [_c('label', [_vm._v("\n          Az \"Author\" mező NEM tartalmazza:\n          "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.filterCustomAuthorNot),
      expression: "data.filterCustomAuthorNot"
    }],
    domProps: {
      "value": (_vm.data.filterCustomAuthorNot)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "filterCustomAuthorNot", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row expanded bottom"
  }, [_c('div', {
    staticClass: "small-4 columns"
  }, [_c('button', {
    staticClass: "button primary trans-uppercase",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Mentés")]), _vm._v(" "), (_vm.data.id) ? _c('button', {
    staticClass: "button alert trans-uppercase",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.remove
    }
  }, [_vm._v("Törlés")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "button secondary trans-uppercase",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v("Vissza")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-29c46c5a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/feeds/Edit.vue
// module id = 468
// module chunks = 2